var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowThinLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{fill:#fff;}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.82,8.71a1,1,0,0,1,0-1.41l.71-.71L9.77,2.34a1,1,0,0,1,1.41,1.41L6.94,8l4.24,4.24a1,1,0,0,1-1.41,1.41L5.53,9.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowThinLeft);
export default __webpack_public_path__ + "static/media/arrow-thin-left.90466f20da8e88296146ba096697501a.svg";
export { ForwardRef as ReactComponent };